<template>
  <v-dialog v-model="showDialog" :max-width="800" :persistent="loading">
    <v-card class="pa-0">
      <modal-bar
        :title="title"
        :loading="loading"
        @onClose="showDialog = false"
      />
      <v-simple-table dense class="pa-2">
        <template #default>
          <thead v-if="!loading" class="custom-table-bordered">
            <tr>
              <th class="text-center">Mes</th>
              <th
                v-for="(item, index) in data?.periods"
                :key="index"
                class="text-center"
              >
                <span class="text-center text-uppercase">{{
                  removeTimeFromDate(
                    item.monthKey,
                    dateFormats.YEAR_MONTH,
                    dateFormats.FULL_MONTH_YEAR
                  )
                }}</span>
              </th>
            </tr>
          </thead>
          <tbody v-if="!loading" class="custom-table-bordered">
            <tr>
              <td scope="row">Pagos en IEL</td>
              <td
                v-for="(item, index) in data?.periods"
                :key="index"
                class="text-center"
              >
                {{ formatNumber(item.ielPayment, '$', 0) }}
              </td>
            </tr>
            <tr>
              <td scope="row">Número de clientes con pagos en IEL</td>
              <td
                v-for="(item, index) in data?.periods"
                :key="index"
                class="text-center"
              >
                {{ formatNumber(item.customersWithIel, '', 0) }}
              </td>
            </tr>
          </tbody>
          <tbody v-if="loading">
            <tr>
              <td colspan="7">
                <v-progress-linear class="mt-3" indeterminate color="teal" />
                <span class="text--disabled"> Cargando información</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-dialog>
</template>
<script>
  import numbersFormats from '@/mixins/numbersFormats';
  import DateFormats from '@/core/constants/DateFormats';
  import dates from '@/mixins/dates';
  import ModalBar from '@/components/modals/ModalBar.vue';

  export default {
    name: 'CustomersIELPaymentTable',
    components: {
      ModalBar,
    },
    mixins: [numbersFormats, dates],
    props: {
      title: {
        type: String,
        default: 'Pagos en IEL',
      },
      value: {
        type: Boolean,
      },
      loading: {
        type: Boolean,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      dateFormats() {
        return DateFormats;
      },
      showDialog: {
        set(value) {
          this.$emit('input', value);
        },
        get() {
          return this.value;
        },
      },
    },
  };
</script>
